<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-2">
            <!-- Card stats -->
            <div class="row pt-md-4">
                <div class="col-md-12">
                    <h1>Base64 to String Converter</h1>
                </div>

                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.input" placeholder="Enter Base64 Value"/>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.output" placeholder="Result Decrypt Text"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12 col-lg-12">
                    <button class="btn btn-dark" @click="calc"><i class="ni ni-sound-wave"></i> Convert</button>
                    <button class="btn btn-primary" @click="clean"><i class="ni ni-button-power"></i> Clear
                    </button>
                    <button v-if="values.output" class="btn btn-info"
                            v-clipboard:copy="values.output"
                            v-clipboard:success="onCopy">
                        <i class="ni ni-ungroup"></i> Copy
                    </button>
                </div>
            </div>

        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--8 bg-dark pb-4">

            <!--Tables-->
            <div class="row mt-5">
                <div class="col-xl-12 mb-12 mb-xl-12">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Latest Results</h3>
                                </div>
                                <div class="col text-right">

                                </div>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <base-table thead-classes="thead-light"
                                        :data="tableData">
                                <template slot="columns">
                                    <th>In</th>
                                    <th>Input Data</th>
                                    <th>Out</th>
                                    <th>Output Data</th>

                                </template>

                                <template slot-scope="{row}">
                                    <th scope="row">
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.input"
                                                v-clipboard:success="onCopy">
                                            {{row.inType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </th>
                                    <th scope="row">
                                        {{row.input}}
                                    </th>
                                    <td>
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.output"
                                                v-clipboard:success="onCopy">
                                            {{row.outType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </td>
                                    <td style="overflow-x:auto;">
                                        {{row.output}}
                                    </td>

                                </template>

                            </base-table>
                        </div>

                    </div>

                    <div class="card shadow mt-4 pl-2 pt-2 pb-2 pr-2 bg-gradient-neutral">
                        <h1>Base64</h1>
                        <p>
                            In computer science Base64 is a group of binary-to-text encoding schemes that represent
                            binary data in an ASCII string format by translating it into a radix-64 representation. The
                            term Base64 originates from a specific MIME content transfer encoding. Each Base64 digit
                            represents exactly 6 bits of data. Three 8-bit bytes (i.e., a total of 24 bits) can
                            therefore be represented by four 6-bit Base64 digits.
                            Common to all binary-to-text encoding schemes, Base64 is designed to carry data stored in
                            binary formats across channels that only reliably support text content. Base64 is
                            particularly prevalent on the World Wide Web where its uses include the ability to embed
                            image files or other binary assets inside textual assets such as HTML and CSS files.
                        </p>
                    </div>
                </div>
            </div>
            <!--End tables-->
        </div>

    </div>
</template>
<script>
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
    Vue.use(VueClipboard);
    import CryptoJS from 'crypto-js';

    export default {
        name: "FromBase64",
        directives: {
            'b-tooltip': BTooltipDirective
        },
        data() {
            return {
                values: {
                    input: null,
                    output: null
                },
                tableData: [],
            };
        },
        methods: {
            onCopy() {
                this.$notify({
                    type: 'success',
                    title: 'Copied to clipboard'
                })
            },
            revert: function () {

            },
            clean: function () {
                this.values.output = null;
                this.values.input = null;
                this.tableData = [];
            },
            calc: function () {
                if (this.values.input) {
                    let parsedWordArray = CryptoJS.enc.Base64.parse(this.values.input);
                    let parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8);

                    this.values.output = parsedStr;
                    this.tableData.unshift({
                        input: this.values.input,
                        inType: "base64",
                        output: this.values.output,
                        outType: "text",
                    });

                    if (this.tableData.length > 8) {
                        this.tableData.splice(8, 1);
                    }
                }
            }
        },
        mounted() {

        }
    };
</script>
<style></style>
